import { render, staticRenderFns } from "./Top10Umsatzbereiche.vue?vue&type=template&id=fdfca752&"
import script from "./Top10Umsatzbereiche.vue?vue&type=script&lang=ts&"
export * from "./Top10Umsatzbereiche.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports